import { StatusPill } from '@vnetwork/ui/data';
import { assetStatusTone, assetProcessingLabel } from './shared';

/** Content-library asset ingest state (pending → normalizing → ready | failed).
 *  While `normalizing` it shows the live sub-step + encode percent
 *  (e.g. "Encoding 45%") instead of an opaque "Processing", so an operator can
 *  see what is happening and roughly how far along. When `error` is set (failed
 *  assets) it surfaces as the pill's tooltip. */
export function AssetStatusPill({
  status,
  stage,
  progress,
  error,
}: {
  status?: string;
  stage?: string;
  progress?: number;
  error?: string;
}) {
  return (
    <span title={error || undefined}>
      <StatusPill tone={assetStatusTone(status)}>
        {assetProcessingLabel(status, stage, progress)}
      </StatusPill>
    </span>
  );
}
